
import HeaderModal from '@components/new-styleguide/HeaderModal.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { email, required } from 'vuelidate/lib/validators';
import { namespace } from 'vuex-class';
import { LoadState } from '@util/types';

const CarHealthModule = namespace('CarHealth');

@Component({
  name: 'CarHealthExportModal',
  components: {
    HeaderModal,
  },
  validations: {
    email: {
      required,
      email,
    },
  },
})
export default class CarHealthExportModal extends Vue {
  @Prop({ default: null })
  private defaultEmail: String;

  @Prop()
  private vehicleId: number;

  @Prop()
  private value: boolean;

  @CarHealthModule.Action('exportCarHealth') exportCarHealth;

  @CarHealthModule.Getter('getExportCarHealthStatus') exportCarHealthStatus;

  @CarHealthModule.Mutation('RESET_EXPORT_CAR_HEALTH') resetExportCarHealth;

  private email: String = '';

  private isLoading = false;

  private exportSuccessful = false;

  created() {
    this.email = this.defaultEmail;
  }

  @Watch('value')
  private onValueChange(newValue) {
    if (newValue) {
      this.exportSuccessful = false;
      this.isLoading = false;
      this.resetExportCarHealth();
    }
  }

  get submitDisabled() {
    if (this.isLoading) {
      return true;
    }

    return !this.email || !this.validateEmail(this.email);
  }

  private close() {
    this.$emit('input', false);
  }

  private handleEmailInput(event) {
    this.email = event.target.value;
  }

  async exportHealth() {
    let from = new Date()
    from.setMonth(from.getMonth() - 3)

    const exportModel = {
      vehicleId: this.vehicleId,
      email: this.email,
      from
    }

    this.isLoading = true;

    try {
      await this.exportCarHealth(exportModel);
      this.exportSuccessful = true;
    } catch(e) {
      console.error(e)
    } finally {
      // simulate loading since export requests returns almost instantly
      setTimeout(() => { this.isLoading = false }, 2000);
    }
  }

  get hasRequestError() {
    return this.exportCarHealthStatus === LoadState.Error
  }

  private validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(String(email).toLowerCase());
  }
}
